export default function(random) {
  return (random() - 0.5) * 1e-6;
}



// WEBPACK FOOTER //
// C:/Dropbox/www/amcharts4dev/node_modules/d3-force/src/jiggle.js